import React from "react";
import { motion } from "framer-motion";
import { FileText, Download, Edit, ExternalLink } from "lucide-react";
import { format } from "date-fns";

import "../../css/document/documentcard.css";

const typeColors = {
  kyc: "type-kyc",
  property_papers: "type-property",
  agreement: "type-agreement",
  offer_letter: "type-offer",
  invoice: "type-invoice",
  other: "type-other"
};

const statusColors = {
  pending: "status-pending",
  verified: "status-verified",
  rejected: "status-rejected"
};

export default function DocumentCard({ document, index, onEdit, isAdmin }) {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = document.file_url;
    link.download = document.document_name;
    link.click();
  };

  return (
    <motion.div
      className="document-card-wrapper"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.05 }}
    >
      <div className="document-card">
        {/* Header */}
        <div className="document-card-header">
          <div className="header-left">
            <div className="doc-icon">
              <FileText size={22} />
            </div>

            <div className="doc-info">
              <h3 className="doc-title">{document.document_name}</h3>

              <div className="badges">
                <span className={`badge ${typeColors[document.document_type]}`}>
                  {document.document_type.replace(/_/g, " ")}
                </span>

                <span className={`badge ${statusColors[document.status]}`}>
                  {document.status}
                </span>
              </div>
            </div>
          </div>

          <button className="icon-btn" onClick={onEdit}>
            <Edit size={16} />
          </button>
        </div>

        {/* Content */}
        <div className="document-card-content">
          {document.related_to && (
            <div className="meta">
              <span className="label">Related to:</span>{" "}
              <span className="value">{document.related_to}</span>
              {document.related_id && (
                <span className="sub-id">
                  (ID: {document.related_id.slice(0, 8)}…)
                </span>
              )}
            </div>
          )}

           {document.dealId?.dealName && (
    <div className="meta">
      <span className="label">Deal:</span>{" "}
      <span className="value">{document.dealId.dealName}</span>
    </div>
  )}

   {/* {isAdmin && document.createdByEmail  && (
    <div className="meta muted">
      Uploaded by: {document.createdByEmail}
    </div>
  )} */}

         {document.createdAt && (
    <div className="meta muted small">
      {format(
        new Date(document.createdAt),
        "MMM dd, yyyy 'at' h:mm a"
      )}
            </div>
          )}

          {document.notes && (
            <div className="notes">
              {document.notes}
            </div>
          )}

          <div className="actions">
            <button
              className="btn outline"
              onClick={() => window.open(document.file_url, "_blank")}
            >
              <ExternalLink size={14} />
              View
            </button>

            {/* <button className="btn outline" onClick={handleDownload}>
              <Download size={14} />
            </button> */}
          </div>
        </div>
      </div>
    </motion.div>
  );
}
